import { Routes } from '@angular/router';
import { AuthGuard as Auth0Guard } from '@auth0/auth0-angular';
import { RedirectGuard } from '@techspert-io/auth';
import { AdminPortalComponent } from './admin-portal/admin-portal.component';
import { ClientOpportunitySearchesComponent } from './admin-portal/clients/client-opportunity-searches/client-opportunity-searches.component';
import { PaymentsComponent } from './admin-portal/payments/payments.component';
import { AuthorisationErrorPageComponent } from './core/authorisation-error-page/authorisation-error-page.component';
import { FinanceGuard } from './features/auth/guards/finance.guard';
import { RolodexGuard } from './features/auth/guards/rolodex.guard';
import { ProjectTrackerGuard } from './features/project-tracker/guards/project-tracker.guard';
import { SearchLayoutComponent } from './features/search/cognisearch/components/search-layout/search-layout.component';
import { UserManagementDashboardComponent } from './features/users/components/user-management-dashboard/user-management-dashboard.component';

export const ROUTES: Routes = [
  { path: '', redirectTo: 'admin', pathMatch: 'full' },
  {
    path: 'error',
    component: AuthorisationErrorPageComponent,
  },
  {
    path: 'admin',
    component: AdminPortalComponent,
    canActivate: [RedirectGuard, Auth0Guard],
    children: [
      { path: '*', redirectTo: 'clients' },
      { path: '', redirectTo: 'clients', pathMatch: 'full' },
      { path: 'beta/search', component: SearchLayoutComponent },
      {
        path: 'clients',
        loadChildren: () =>
          import('./features/clients-dashboard/clients-dashboard.module').then(
            (m) => m.ClientsDashboardModule
          ),
      },
      {
        path: 'clients/:clientId/opportunity-kick-off',
        loadChildren: () =>
          import('./features/opportunity-kick-off/opportunity-kick-off.module').then(
            (m) => m.OpportunityKickOffModule
          ),
      },
      {
        path: 'clients/:clientId/opportunity-kick-off-template',
        loadChildren: () =>
          import('./features/opportunity-kick-off-template/opportunity-kick-off-template.module').then(
            (m) => m.OpportunityKickOffTemplateModule
          ),
      },
      {
        path: 'client/:clientId/opportunity/:opportunityId/dashboard',
        loadChildren: () =>
          import('./features/opportunity-dashboard/opportunity-dashboard.module').then(
            (m) => m.OpportunityDashboardModule
          ),
      },
      {
        path: 'client/:id/opportunity/:opportunity/search/:search/phase/:phase',
        component: ClientOpportunitySearchesComponent,
      },
      {
        path: 'client/:id/opportunity/:opportunity',
        redirectTo:
          'client/:id/opportunity/:opportunity/search/all-searches/phase/identified',
      },
      {
        path: 'campaigns',
        loadChildren: () =>
          import('./features/campaigns-dashboard/campaigns-dashboard.module').then(
            (m) => m.CampaignsDashboardModule
          ),
      },
      {
        path: 'experts',
        loadChildren: () =>
          import('./features/expert-management/expert-management.module').then(
            (m) => m.ExpertManagementModule
          ),
      },
      {
        path: 'users',
        component: UserManagementDashboardComponent,
      },
      {
        path: 'expert-outreach-status',
        loadChildren: () =>
          import('./features/expert-outreach-status/expert-outreach-status.module').then(
            (m) => m.ExpertOutreachStatusModule
          ),
      },
      {
        path: 'manual-upload',
        loadChildren: () =>
          import('./features/manual-upload/manual-upload.module').then(
            (m) => m.ManualUploadModule
          ),
      },
      { path: 'project-payments', component: PaymentsComponent },
      {
        path: 'outreach-templates',
        loadChildren: () =>
          import('./features/outreach-templates/outreach-templates.module').then(
            (m) => m.OutreachTemplatesModule
          ),
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./features/payments/out-of-project-payments.module').then(
            (m) => m.OutOfProjectPaymentsModule
          ),
      },
      {
        path: 'sourcing',
        loadChildren: () =>
          import('./features/search/search.module').then((m) => m.SearchModule),
      },
      {
        path: 'profiles',
        loadChildren: () =>
          import('./features/profiles-view/profiles-view.module').then(
            (m) => m.ProfilesViewModule
          ),
      },
      {
        path: 'finance',
        loadChildren: () =>
          import('./features/finance/finance.module').then(
            (m) => m.FinanceModule
          ),
        canActivate: [FinanceGuard],
      },
      {
        path: 'panels',
        loadChildren: () =>
          import('./features/rolodex/rolodex.module').then(
            (m) => m.RolodexModule
          ),
        canActivate: [RolodexGuard],
      },
      {
        path: 'project-tracker',
        loadChildren: () =>
          import('./features/project-tracker/project-tracker.module').then(
            (m) => m.ProjectTrackerModule
          ),
        canActivate: [ProjectTrackerGuard],
      },
      {
        path: 'transcript-review',
        loadChildren: () =>
          import('./features/transcript-review/transcript-review.routes').then(
            (m) => m.TRANSCRIPT_REVIEW_ROUTES
          ),
      },
      {
        path: 'rfq-brief-review',
        loadChildren: () =>
          import('./features/rfq-brief-review/rfq-brief-review.routes').then(
            (m) => m.RFQ_BRIEF_REVIEW_ROUTES
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
